import { useCustomTable } from "@/hooks/use-custom-table";
import { CustomerDto } from "@/models/club";
import { CustomLink } from "@/styles/shared/link/link.style";
import {
  ActionIcon,
  Button,
  Container,
  DirectionProvider,
  Group,
  Menu,
} from "@mantine/core";
import {
  IconAddressBook,
  IconDotsVertical,
  IconEdit,
  IconPlus,
  IconUser,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
} from "mantine-react-table";
import { MRT_Localization_FA } from "mantine-react-table/locales/fa/index.cjs";
import moment from "moment-jalaali";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetCustomerPagination } from "./hooks/useGetCustomers";

moment.locale("fa");
moment.loadPersian();

function DesktopCustomers() {
  const navigate = useNavigate();
  const [globalFilter, setGlobalFilter] = useState();

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const { data, isLoading, isFetching } = useGetCustomerPagination({
    Count: pagination?.pageSize,
    Skip: pagination?.pageIndex * pagination?.pageSize,
    Term: globalFilter,
  });

  const columns = useMemo<MRT_ColumnDef<CustomerDto>[]>(
    () => [
      { header: "معرف", accessorKey: "referrer", enableSorting: false, enableColumnFilter: false, Cell: ({ row }) => row.original.referrer || "—" },
      {
        header: "نام",
        accessorKey: "firstName",
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        header: "نام خانواده",
        accessorKey: "lastName",
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        header: "شماره تماس",
        accessorKey: "phoneNumber",
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        header: "تاریخ عضویت",
        accessorKey: "creationTime",
        enableSorting: false,
        enableColumnFilter: false,
        accessorFn: ({ creationTime }) =>
          creationTime
            ? moment(creationTime).format("HH:mm ,jYYYY/jMM/jDD")
            : "-",
      },
    ],
    []
  );

  const table = useCustomTable({
    columns: columns,
    data: data?.result || [],
    localization: MRT_Localization_FA,
    rowCount: data?.count,
    autoResetPageIndex: false,
    manualPagination: true,
    enableRowActions: true,
    defaultColumn: {
      maxSize: 200,
      minSize: 50,
      size: 50, //default size is usually 180
      grow: true,
    },
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    state: {
      isLoading: isLoading || isFetching,
      pagination,
    },
    renderTopToolbarCustomActions: () => (
      <Group>
        <CustomLink to="/dashboard/customers/add">
          <Button rightSection={<IconPlus />} variant="outline">
            افزودن مشتری
          </Button>

        </CustomLink>

        <CustomLink to="/dashboard/profile/importContact">
          <Button rightSection={<IconAddressBook />} variant="outline" >
            افزودن مشتری از طریق فایل vcf.
          </Button>
        </CustomLink>

        {/* <ActionIcon variant="default" size="lg"  >
          <IconAddressBook stroke={1} />
        </ActionIcon> */}
      </Group>
    ),
    renderRowActions: ({ row }) => (
      <Group wrap="nowrap" gap="xs">
        <Menu>
          <Menu.Target>
            <ActionIcon size="" variant="subtle">
              <IconDotsVertical />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              onClick={() =>
                navigate(`/dashboard/customers/details/${row?.original?.id}`)
              }
              leftSection={<IconUser size={14} />}
            >
              مشاهده اطلاعات
            </Menu.Item>
            <Menu.Item
              onClick={() =>
                navigate(`/dashboard/customers/edit/${row?.original?.id}`)
              }
              leftSection={<IconEdit size={14} />}
            >
              ویرایش اطلاعات
            </Menu.Item>
            {/* <Menu.Item leftSection={<IconTrash color="red" size={14} />}>
              حذف
            </Menu.Item> */}
          </Menu.Dropdown>
        </Menu>
      </Group>
    ),
  });

  return (
    <Container size="md">
      <DirectionProvider>
        <MantineReactTable table={table} />
      </DirectionProvider>
    </Container>
  );
}

export default DesktopCustomers;
